export default "/static/assets/lead-white.01d8d5ec7a8f023bd51076d0c1d8d035.svg";